let common = {};
common.platformCode = 'management';
common.platformVersion = '1.1.1';
common.profiles = 'zxx';
common.ip = 'localhost';
common.port = 9002;
common.resourcePort = 88;
common.hasPrivilege = true;
if (common.profiles === 'prod') {
    common.ip = '223.254.2.14';
    common.port = 9696;
    common.resourcePort = 19696;
} else if (common.profiles === 'test') {
    common.ip = 'localhost';
    common.port = 9001;
    common.resourcePort = 80;
}else if (common.profiles === 'zxx') {
    common.ip = '192.168.0.199';
    common.port = 9001;
    common.resourcePort = 80;
}
// 青柿平台国标编码（青柿A编码福田用,外网的话用拼接的编码）
common.qsSerial = '44030499992008063007';
common.posterUrl = 'http://223.254.2.36:10000/sms/44030499992020000001/snap/';
if (common.profiles === 'gongan') {
    common.ip = '190.64.12.175';
    common.port = 9696;
    common.resourcePort = 19696;
    common.posterUrl = 'http://190.64.12.174:10000/sms/44030499992020000003/snap/';
}
/*common.ip = '223.254.2.14';
common.port = 9696;
common.resourcePort = 19696;
common.posterUrl = 'http://223.254.2.36:10000/sms/44030499992020000001/snap/';*/
common.api = 'http://' + common.ip + ':' + common.port + '/';
common.resource = 'http://' + common.ip + ':' + common.resourcePort + '/';
common.socketUrl = 'ws://' + common.ip + ':' + common.port + '/server/message';


export default common;

